import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { CreateBankTransactionModel } from '../../../types/bankAccount';
import Button from '../buttons/Button';
import { formatEuroCents } from '../../../utils/bankAccountUtil';

type HandleUnmatchedProps = {
  unmatched: CreateBankTransactionModel[];
  onConfirm: (selected: CreateBankTransactionModel[]) => void;
};

export default function HandleUnmatchedTransactionsView({
  unmatched,
  onConfirm,
}: HandleUnmatchedProps) {
  const { t, i18n } = useTranslation('', { keyPrefix: 'page.financial.accountEntry' });

  const [selected, setSelected] = useState<CreateBankTransactionModel[]>([]);

  const toggle = (transaction: CreateBankTransactionModel) => {
    setSelected((prev) =>
      prev.includes(transaction) ? prev.filter((u) => u !== transaction) : [...prev, transaction],
    );
  };

  const toggleAll = () => {
    if (selected.length === unmatched.length) {
      setSelected([]);
    } else {
      setSelected(unmatched);
    }
  };

  return (
    <div>
      <ul className="mb-4 space-y-4">
        {unmatched.length === 0 && <p>{t('noMatches')}</p>}
        {unmatched.map((transaction, index) => (
          <li
            key={`${index}_unmatched_${transaction.description}`}
            onClick={() => toggle(transaction)}
            className="flex cursor-pointer items-center gap-4 rounded-lg border bg-white p-4 shadow-sm">
            <input
              type="checkbox"
              checked={selected.includes(transaction)}
              onChange={() => toggle(transaction)}
            />
            <div className="flex flex-col">
              <div className="font-medium">
                {transaction.description}
              </div>
              <div className="text-sm text-gray-600">
                {formatEuroCents(transaction.amount, i18n.language)}
              </div>
            </div>
          </li>
        ))}
      </ul>

      <div className="flex justify-end gap-2">
        <Button 
          variant="secondary" 
          type="button" 
          onClick={toggleAll}
          disabled={unmatched.length === 0}>
          {selected.length === unmatched.length ? t('deselectAll') : t('selectAll')}
        </Button>
        <Button 
          variant="primary-dark" 
          type="button" 
          onClick={() => onConfirm(selected)}>
          {t('completeImport')}
        </Button>
      </div>
    </div>
  );
}
